import axios from 'axios';
import apiClient from './api';

// Маршруты магазина лежат в routes/api.php, поэтому им нужен префикс /api.
// Если REACT_APP_API_URL уже заканчивается на /api, второй раз его не добавляем.
const baseURL = (apiClient.defaults.baseURL || '').replace(/\/+$/, '');
const PREFIX = baseURL.endsWith('/api') ? '/shop' : '/api/shop';

// Приводим ошибки к единому виду: { message, errors?, status? }.
// Отмену запроса (AbortController) пробрасываем как есть: в компонентах её нужно игнорировать.
const unwrap = (promise) =>
    promise
        .then((res) => res.data)
        .catch((error) => {
            if (axios.isCancel(error)) throw error;
            const data = error.response?.data;
            throw {
                message: data?.message || 'Не удалось связаться с сервером. Попробуйте ещё раз.',
                errors: data?.errors,
                status: error.response?.status,
            };
        });

export const shopApi = {
    // type: 'part' | 'accessory' — категории и бренды берутся только выбранного раздела
    filters: (type = 'part', signal) =>
        unwrap(apiClient.get(`${PREFIX}/filters`, { params: { product_type: type }, signal })),
    // product_type передаётся внутри params из ShopCatalog
    products: (params, signal) => unwrap(apiClient.get(`${PREFIX}/products`, { params, signal })),
    product: (slug, signal) => unwrap(apiClient.get(`${PREFIX}/products/${encodeURIComponent(slug)}`, { signal })),
    checkCart: (items) => unwrap(apiClient.post(`${PREFIX}/cart/check`, { items })),
    createOrder: (payload) => unwrap(apiClient.post(`${PREFIX}/orders`, payload)),
};